const billFor = [
  { id: 1, name: 'China' },
  { id: 2, name: 'Chile' },
  { id: 3, name: 'México' }
]

export default billFor
